
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 25","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.752 2.826c.88.879 1.319 1.946 1.319 3.202s-.44 2.324-1.319 3.203-1.946 1.319-3.202 1.319-2.324-.44-3.203-1.32C6.468 8.353 6.03 7.285 6.03 6.029s.44-2.323 1.318-3.202c.88-.88 1.947-1.319 3.203-1.319 1.256 0 2.323.44 3.202 1.319zm-.164 8.43a5.865 5.865 0 002.19-2.19c.533-.926.8-1.939.8-3.038a5.977 5.977 0 00-.8-3.037A5.865 5.865 0 0013.587.8 5.977 5.977 0 0010.55 0a5.978 5.978 0 00-3.038.8 5.865 5.865 0 00-2.19 2.19 5.977 5.977 0 00-.8 3.038c0 1.1.266 2.112.8 3.038a5.865 5.865 0 002.19 2.19c.926.534 1.939.8 3.038.8a5.977 5.977 0 003.038-.8zm6.004 10.597c0 .22-.07.4-.212.541a.733.733 0 01-.541.212H2.26c-.22 0-.4-.07-.542-.212a.733.733 0 01-.212-.541v-1.978c0-1.32.471-2.45 1.413-3.391.942-.942 2.072-1.413 3.391-1.413.251 0 .644.078 1.178.235 1.067.346 2.087.518 3.06.518.974 0 1.995-.172 3.062-.518.534-.157.926-.235 1.177-.235 1.32 0 2.45.47 3.391 1.413.942.942 1.413 2.072 1.413 3.39v1.979zm-6.405-7.96c-.44.126-.8.22-1.083.283a7.94 7.94 0 01-1.554.141 7.94 7.94 0 01-1.554-.141 19.528 19.528 0 01-1.084-.283c-.659-.22-1.193-.33-1.6-.33a6.178 6.178 0 00-3.156.848A6.259 6.259 0 00.848 16.72 6.177 6.177 0 000 19.875v1.978c0 .628.22 1.161.66 1.6.44.44.973.66 1.6.66h16.58a2.18 2.18 0 001.601-.66c.44-.439.66-.972.66-1.6v-1.978a6.18 6.18 0 00-.848-3.156 6.259 6.259 0 00-2.308-2.308 6.177 6.177 0 00-3.156-.847c-.408 0-.941.11-1.6.33z"}})])
          )
        }
      }
    